import ToastUtils from '@/utils/ToastUtils';
import { getFileSuffix } from '@/utils';
import { cloneDeep } from 'lodash';
import UsualSkillOssUpload from './UsualSkillOssUpload';

import { agentFileBucketName } from '@/utils/Page/constant';
import { getFileTypeBySuffix } from '@/utils';
import { fileTypeMap } from '@/utils/Page/constant';
import { parseStatusDic } from '@/utils/Page/constant';
import { getAgentFileDirName } from '@/utils/Page/constant';

const UsualUpload = (props) => {
    const UploadConfig = {
        ossBucketName: agentFileBucketName.oss
    };
    const { setAgentFile, agentFile, uploadItem } = props;
    const onFileChange = (file) => {
        let ext_type = getFileSuffix(file?.name);
        let type = getFileTypeBySuffix(ext_type);
        let list = agentFile.filter((ele) => ele.type !== fileTypeMap.link) || [];
        list.push({
            type: type,
            open: 0,
            uid: file.uid,
            progress: 0,
            status: 1,
            name: file?.name.substring(0, file?.name.lastIndexOf('.')), //不要后缀
            size: file?.size,
            ext_type: ext_type,
            parse_status: parseStatusDic.ing
        });
        setAgentFile(list);
        if (props.setReferences) {
            props.setReferences([]);
        }
        console.log(list, '选择完成');
    };
    //上传中
    const processFunc = (progress, file) => {
        let list = cloneDeep(agentFile);
        let curFile = list.find((ele) => ele.uid === file.uid);
        curFile.progress = progress;
        setAgentFile(list);
    };
    //上传完成
    const afterUpload = (obsRes, file) => {
        console.log(obsRes, '上传完成obsRes');
        let list = cloneDeep(agentFile);
        let curFile = list.find((ele) => ele.uid === file.uid);
        curFile.progress = 1;
        curFile.status = 2;
        curFile.file_url = obsRes.fileUrl;
        curFile.fingerprint = obsRes.md5;
        curFile.object_id = obsRes.objectKey;
        curFile.bucket = obsRes.bucketName;
        setAgentFile(list);
    };
    const errorFunc = (error, file) => {
        if (error.message) {
            ToastUtils.showToast(error.message);
            console.log('文件已存在、类型不支持或大小超限');
        } else {
            let list = cloneDeep(agentFile);
            let curFile = list.find((ele) => ele.uid === file.uid);
            curFile.process = 0;
            curFile.status = 0;

            setAgentFile(list);
        }
    };
    return (
        <>
            <UsualSkillOssUpload
                fileList={agentFile}
                onChange={onFileChange}
                disabled={agentFile.length > 4}
                processFunc={processFunc}
                uploadCompleteFunc={afterUpload}
                bucketName={agentFileBucketName.oss}
                errorFunc={errorFunc}
                dirname={getAgentFileDirName()}
                uploadItem={uploadItem}
                {...UploadConfig}
            ></UsualSkillOssUpload>
        </>
    );
};
export default UsualUpload;
